import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  microFrontEnds: [
    {
      remoteEntry: 'https://payments-panel.test.eshopworld.net/v2/dist/remoteEntry.js',
      remoteName: 'paymentPanel',
      exposedModule: './PaymentPanelModule',
      rel: 'paymentPanel',
      moduleId: 'default',
      type: 'script'
    }
  ],
  fraudBootstrapScriptUrl: 'https://payments-panel.test.eshopworld.net/js/fraudbootstrap.min.js',
  paymentsPanelApiUrl: 'https://payments-panel.test.eshopworld.net',
  composableApiUrl: 'https://api.test.esw.com',
  feroot: {
    bundleId: '5556de3e-4a74-48de-b1d8-205e4ab95ad7',
    enabled: true
  },
  appInsights: '0aa7d0d1-f956-44a8-8ed9-8b704f7af96e'
};
